var club_details_styles = {
  club_details: {
    display: "flex",
    width: "100%",
    maxWidth: "251px",
    padding: "24px 0px",
    flexDirection: "column" as const,
    alignItems: "flex-start" as const,
    gap: "12px",
  },
  club_name: {
    alignSelf: "stretch",
    color: "var(--Black---1000, #191924)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    width: "200px"
  },
  details: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "flex-start" as const,
    gap: "2px" as const,
    alignSelf: "stretch" as const,
  },
  data: {
    display: "flex",
    height: "0px" as const,
    flexDirection: "column" as const,
    justifyContent: "center" as const,
    alignSelf: "stretch" as const,
    color: "var(--Black---1000, #191924)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "0px",
    opacity: 0.5,
    margin: "10px 0",
  },
};

export default club_details_styles;
